import type { ApiExternalUserProfile } from '../../api/userProfile/userProfileModels';

import { SessionStorageFacade } from '../../../../facades/storage/sessionStorageFacade';

const USER_PROFILE_STORAGE_KEY = 'userProfile';
const key = (userId: string) => {
    return `${USER_PROFILE_STORAGE_KEY}_${userId}`;
};

const userProfileSession = {
    setProfile: (userId: string, profile: ApiExternalUserProfile) => {
        SessionStorageFacade.instance.addObject(key(userId), profile);
    },
    getProfile: (userId: string) =>
        SessionStorageFacade.instance.getObject<ApiExternalUserProfile>(key(userId)),
};

export default userProfileSession;
